import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/Home/Home';
import Layout from '../layout';
import AvatarPage from './pages/Avatar/AvatarPage';
import routes from './routs';

export function App() {
  return (
    <Routes>
      <Route path={routes.home} element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path={routes.avatar} element={<AvatarPage />} />
        <Route path="*" element={<Navigate replace to={routes.home} />} />
      </Route>
    </Routes>
  );
}

export default App;
